import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { ConfirmationService } from 'primeng/api';
import { selectPersonasList } from '../../store/selectors/personas.selectors';
import { IAppState } from '../../store/app.state';
import { tap } from 'rxjs/operators';
import { DownloadService } from 'src/app/services/download.service';
import { Table } from 'primeng/table';
import { selectFormulariosList } from 'src/app/store/selectors/formularios.selectors';
import { CreateFormulario, CreateFormularioSuccess, DeleteFormulario, DeleteFormularioSuccess, GetFormularios, UpdateFormulario, UpdateFormularioSuccess } from 'src/app/store/actions/formularios.actions';

// import { GoogleapisService } from 'src/app/services/googleapis.service';
// declare const gapi;

@Component({
  selector: 'app-formularios',
  templateUrl: './formularios.component.html',
  styleUrls: ['./formularios.component.scss']
})
export class FormulariosComponent implements OnInit, OnDestroy{
  @ViewChild('dt', { static: false }) table: Table;

  formularios = this.store$.pipe(
    select(selectFormulariosList)
  );

  formSubmitSubscription = this.actions$.pipe(
    ofType(UpdateFormularioSuccess, DeleteFormularioSuccess, CreateFormularioSuccess),
    tap(_ => {
        this.store$.dispatch(GetFormularios());
        this.displayForm = false;
        this.spinner = false;
    })
  ).subscribe();

  downloadItems = [
    {label: 'CSV', command: () => { this.downloadService.exportCSV('formularios', this.table)}},
    {label: 'PDF', command: () => { this.downloadService.exportPdf('formularios', this.table)}},
  ];

  formFormulario: FormGroup;
  cols: any[];
  mode = '';
  header = '';
  displayForm = false;
  spinner = false;

  constructor(
    // private googleApisService: GoogleapisService,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private store$: Store<IAppState>,
    private actions$: Actions,
    public downloadService: DownloadService
  ) {
    this.formFormulario = this.formBuilder.group({
      titulo: new FormControl(''),
      descripcion: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.cols = [
      { field: 'titulo', header: 'Nombre del formulario', exportable: true },
      { field: 'editor', header: 'URL para editar formulario', exportable: true },
      { field: 'published', header: 'URL para contestar el formulario', exportable: true },
      { field: 'summary', header: 'Respuestas del Formulario', exportable: true },
      { field: 'sheet', header: 'Excel del Formulario', exportable: true },
      { field: 'acciones', header: 'Acciones', exportable: false }
    ];

    this.store$.dispatch(GetFormularios())
  }

  async ngOnDestroy() {
    this.formSubmitSubscription.unsubscribe();
  }

  agregarFormulario() {
    this.mode = 'AGREGAR'
    this.header = 'Agregar Formulario'
    this.formFormulario.patchValue({
      _id: '',
      titulo: '',
      descripcion: '',
      nombre: '',
      expediente: '',
    })
    this.formFormulario.enable();

    this.displayForm = true;
  }

  borrarFormulario(formulario: any) {
    this.confirmationService.confirm({
      header: 'Borrar Formulario',
      message: `¿Seguro que quiere borrar el formulario '${formulario.titulo}'?`,
      acceptLabel: 'Aceptar',
      rejectVisible: false,
      accept: async () => {
        this.store$.dispatch(DeleteFormulario({id: formulario._id}))
      }
    });
  }

  submitForm() {
    this.spinner = true;
    const form: any = this.formFormulario.getRawValue();

    if (this.mode === 'AGREGAR') {
      const payload : any = {
        ...form,
      }

      this.store$.dispatch(CreateFormulario({formularios: payload}));
    } else if (this.mode === 'EDITAR') {
      const payload : any = {
        ...form,
      }

      this.store$.dispatch(UpdateFormulario({id: form._id, formularios: payload}));
    }

    return;
  }
}
